































import {Component, Mixins} from 'vue-property-decorator'
import {$, PageCollection} from 'simpli-web-sdk'
import {MixinFilter} from '@/components/mixins/MixinFilter'
import DeliveryCanceledResponse from '@/model/response/DeliveryCanceledResponse'
import DeliveryCanceledRequest from '@/model/request/DeliveryCanceledRequest'
import FilterDeliveryCanceled from '@/components/filters/FilterDeliveryCanceled.vue'
import {AppConfig} from '@/config/app.config'
import {snakeCase} from 'lodash'
import * as Helper from '@/helpers'
import FilterToggle from '@/components/FilterToggle.vue'

const metaInfo = () => ({
title: $.t('view.reports.deliveryCanceled.title'),
})

@Component({
  metaInfo,
  components: {FilterToggle, FilterDeliveryCanceled},
})
export default class ReportsDeliveryCanceledView extends Mixins(MixinFilter) {
    filter = new DeliveryCanceledRequest()
    collection = new PageCollection(DeliveryCanceledResponse, this.filter, 10)

    AppConfig = AppConfig

    async created() {
      this.collection.orderBy = 'nome'
      this.collection.asc = true
    }

  async downloadData(xlsx: boolean) {
    if (!xlsx) {
        const csv = new PageCollection(DeliveryCanceledResponse, this.filter, null, null)

        const fetch = async () => await csv.search()
        await $.await.run(fetch, 'download')
        csv.downloadCsv(snakeCase($.t('view.reports.deliveryCanceled.title')))
    } else {
        await $.await.run(() => Helper.downloadXlsx(
          $.t('view.reports.deliveryCanceled.title'),
          new DeliveryCanceledResponse().$endpoint,
          this.filter,
          DeliveryCanceledResponse,
          'DeliveryCanceledResponse',
          ), 'download')
    }
  }
}
